import { UIKitTheme } from 'ui/themes/getUIKitTheme'

/* `main color` means not hover, not active, not focused, etc */
export const getMainTextColor = (theme: UIKitTheme, overColoredPad = false) => {
  if (overColoredPad) {
    return theme.uiKit.colors.global.general.main
  }
  return theme.uiKit.colors.theme.brand.primary
}
